module.exports = "<p>\n  page works!\n</p>\n"